module.exports = __webpack_public_path__ + "img/card-rp-information-request-report.c010dcd7.svg";